import { AfterContentInit, Component, computed, ContentChildren, QueryList, Signal, signal } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { OverlayModule } from '@angular/cdk/overlay';
import { MatIconButton } from '@angular/material/button';
import { MatTooltip } from '@angular/material/tooltip';
import { MatProgressBar } from '@angular/material/progress-bar';
import { TableRowActionExecutingDirective } from 'angular-components/table-system';

@Component({
  selector: 'eurogard-table-row-action-overlay',
  templateUrl: './table-row-action-overlay.component.html',
  styleUrls: ['./table-row-action-overlay.component.scss'],
  standalone: true,
  imports: [
    MatIcon,
    OverlayModule,
    MatIconButton,
    MatTooltip,
    MatProgressBar,
  ],
})
export class TableRowActionOverlayComponent implements AfterContentInit {
  isOpen = false;

  @ContentChildren(TableRowActionExecutingDirective, { descendants: true })
  actions!: QueryList<TableRowActionExecutingDirective>;

  isAnyExecuting!: Signal<boolean>;

  protected readonly darkMode = signal(document.body.classList.contains('dark-theme'));

  protected checkDarkMode() {
    this.darkMode.set(document.body.classList.contains('dark-theme'));
  }

  ngAfterContentInit() {
    this.isAnyExecuting = computed(() => this.actions?.some(action => action.shown()) ?? false);
  }

  close() {
    this.isOpen = false;
  }
}
